var map = {
	"./Group 22302.png": 1314,
	"./avatar-christmas.webp": 1315,
	"./bottom-bg-christmas.webp": 1316,
	"./btn-active.png": 1317,
	"./content-deco-1.webp": 1318,
	"./content-deco-2.webp": 1319,
	"./content-deco-3.webp": 1320,
	"./content-deco-4.webp": 1321,
	"./deco-3.webp": 1322,
	"./deposit-icon.webp": 1323,
	"./home-icon-active.webp": 1324,
	"./home-icon.webp": 1325,
	"./live-icon-active.webp": 1326,
	"./live-icon.webp": 1327,
	"./master-bg.jpg": 1328,
	"./me-icon-active.webp": 1329,
	"./me-icon.webp": 1330,
	"./platform.png": 1331,
	"./platform.webp": 1332,
	"./promos-icon-active.webp": 1333,
	"./promos-icon.webp": 1334,
	"./promos.webp": 1335,
	"./service-christmas.webp": 1336,
	"./snowman.webp": 1337,
	"./sponsor-icon-active.webp": 1338,
	"./sponsor-icon.webp": 1339,
	"./title-deco-left.webp": 1340,
	"./title-deco-right.webp": 1341,
	"./tree.webp": 1342,
	"./vip-icon.webp": 1343,
	"./vip.webp": 1344,
	"./withdraw-icon.webp": 1345,
	"./wwr-img.webp": 1346
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;